<template>
  <div class="tip-container user-text">
    <v-icon :color="color" class="mr-2">{{icon}}</v-icon>
    <div class="body-1 text-xs-left">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
    color: String
  }
}
</script>

<style scoped lang="scss">
.body-1,
i.v-icon {
  color: rgba(0, 0, 0, 0.6);
}
.tip-container {
  border-radius: 14px;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: row;
  padding: 10px;
  min-height: fit-content;
  -webkit-box-shadow: 4px 4px 25px -2px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 4px 4px 25px -2px rgba(0, 0, 0, 0.3);
  box-shadow: 4px 4px 25px -2px rgba(0, 0, 0, 0.3);
  & > .v-icon {
    margin: auto;
  }
  & > div {
    flex: 1 auto;
  }
}
</style>
